import {AbstractControl} from '@angular/forms';
import {FieldConfig} from './field.config';

export type ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: Partial<FieldConfig<any>>,
    control: AbstractControl
) => void;
